import React from 'react';
import { RegisterCommandsWithRegistry } from '@atlassian/jira-command-palette/src/ui/register-commands/index.tsx';
import type { RegisterCommandsProps } from '@atlassian/jira-command-palette/src/ui/register-commands/types.tsx';
import type { COMMAND_PALETTE_REGISTRY_ID } from '../../common/constants/registry/index.tsx';

export const RegisterCommands = (
	props: RegisterCommandsProps<COMMAND_PALETTE_REGISTRY_ID>,
): React.JSX.Element => <RegisterCommandsWithRegistry<COMMAND_PALETTE_REGISTRY_ID> {...props} />;
